function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) {
    elementToFocus?.focus();

    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function handleCardHoverVideo(event) {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const media = event.target.closest('.media--hover-effect');
  if (!media) return;

  const video = media.querySelector('video');
  if (!video) return;

  if (media.contains(event.relatedTarget)) return;

  if (event.type === 'mouseover') {
    video.play().catch(() => {});
  } else {
    video.pause();
    video.currentTime = 0;
  }
}

document.addEventListener('mouseover', handleCardHoverVideo);
document.addEventListener('mouseout', handleCardHoverVideo);

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      // document.documentElement.classList.remove('overflow-hidden');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.documentElement.classList.add('overflow-hidden');
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
    document.documentElement.classList.remove('overflow-hidden');
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
    if (poster.hasAttribute('autoplay')) {
      poster.click();
    }
  }

  loadContent(focus = true) {
    // window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      // if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.setDimension();

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.setDimension();
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element[this.client] > 0);
    if (this.sliderItemsToShow.length < 2) return;

    this.sliderItemOffset = this.sliderItemsToShow[1][this.offset] - this.sliderItemsToShow[0][this.offset];

    this.slidesPerPage = Math.floor(
      (this.slider[this.client] - this.sliderItemsToShow[0][this.offset]) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider[this.scrollDimension] / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider[this.scrollDimension] === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  setDimension() {
    this.dimension = 'horizontal';
    if (window.innerWidth >= BREAKPOINTS.tablet && this.getAttribute('data-dimension-desktop')) {
      this.dimension = this.getAttribute('data-dimension-desktop');
    }

    this.offset = this.dimension === "vertical" ? "offsetTop" : "offsetLeft";
    this.client = this.dimension === "vertical" ? "clientHeight" : "clientWidth";
    this.scrollDimension = this.dimension === "vertical" ? "scrollTop" : "scrollLeft";
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider[this.client] + this.slider[this.scrollDimension] - offset;
    return element[this.offset] + element[this.client] <= lastVisibleSlide && element[this.offset] >= this.slider[this.scrollDimension];
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider[this.scrollDimension] + step * this.sliderItemOffset
        : this.slider[this.scrollDimension] - step * this.sliderItemOffset;

    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      [this.dimension === 'vertical' ? 'top' : 'left']: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider[this.scrollDimension] + this.sliderFirstItemNode[this.client] * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider[this.scrollDimension] + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider[this.scrollDimension] +
      this.sliderFirstItemNode[this.client] *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', e => this.onVariantChange(e));
  }

  /**
   * Fallback for products with exactly one variant. The picker only renders a fieldset
   * per entry in `product.options_with_values`, which for a combined-listing product can
   * have fewer entries than `variant.options` — Shopify injects the shared combined-listing
   * value into option1 and pushes the product's own placeholder into option2 (e.g.
   * options: ["Classic", "Default Title"]), so positional matching in updateMasterId never
   * lines up. With only one variant to begin with, there's nothing else it could be.
   */
  getSoleVariantFallback() {
    const variants = this.getVariantData();
    return variants.length === 1 ? variants[0] : null;
  }

  /**
   * Combined listings: when the changed input represents an option_value that points to
   * a different (sibling) child product via data-product-url, switch to that product
   * instead of running the local variant-change pipeline. Prefers the seamless section
   * swap registered by combined-listings-swap.liquid; falls back to a full navigation.
   * Returns true if navigation/swap was triggered so callers can early-out.
   */
  maybeNavigateToCombinedListingProduct(event) {
    if (!event) return false;
    const target = event.target;
    if (!target) return false;

    let productUrl = '';
    if (target.tagName === 'SELECT') {
      const opt = target.selectedOptions && target.selectedOptions[0];
      productUrl = (opt && opt.dataset && opt.dataset.productUrl) || '';
    } else {
      productUrl = (target.dataset && target.dataset.productUrl) || '';
    }

    if (!productUrl) return false;

    const currentProductUrl = this.dataset.url || '';
    // Normalise away query/hash before comparing — product_url is always a clean path.
    const stripQuery = (u) => (u || '').split('?')[0].split('#')[0];
    if (stripQuery(productUrl) === stripQuery(currentProductUrl)) return false;

    const sectionId = this.dataset.section;
    const swap = window.__combinedListingsSwap && window.__combinedListingsSwap[sectionId];
    if (swap && typeof swap.swapTo === 'function') {
      swap.swapTo(productUrl);
    } else {
      window.location.href = productUrl;
    }
    return true;
  }

  onVariantChange(e) {
    if (this.maybeNavigateToCombinedListingProduct(e)) return;

    this.updateOptions();
    this.updateMasterId();
    //this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses(e);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    if (!this.currentVariant) {
      this.currentVariant = this.getSoleVariantFallback();
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    // Keep any other query params (UTMs, click ids, etc.) — only swap the variant.
    const params = new URLSearchParams(window.location.search);
    params.set('variant', this.currentVariant.id);
    window.history.replaceState({}, '', `${this.dataset.url}?${params.toString()}${window.location.hash}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses(e) {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(e, optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(e, listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      // Combined listings: leave sibling-product options untouched — their availability
      // is server-rendered and not part of the current product's variant matrix.
      if (input.dataset && input.dataset.productUrl) return;

      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

renderProductInfo() {
  const requestedVariantId = this.currentVariant.id;
  const sectionId = this.dataset.originalSection || this.dataset.section;

  return fetch(
    `${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`
  )
    .then((response) => response.text())
    .then((responseText) => {
      if (this.currentVariant.id !== requestedVariantId) return;

      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const destination = document.getElementById(`price-${this.dataset.section}-${this.dataset.productId}`);
      const source = html.getElementById(`price-${sectionId}-${this.dataset.productId}`);
      const inventorySource = html.getElementById(`Inventory-${sectionId}`);
      const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
      const volumePricingSource = html.getElementById(`Volume-${sectionId}`);
      const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
      const pricePerItemSource = html.getElementById(`Price-Per-Item-${sectionId}`);
      const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

      if (source && destination) destination.innerHTML = source.innerHTML;
      if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;

      if (volumePricingSource && volumePricingDestination) {
        volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
      }

      if (pricePerItemSource && pricePerItemDestination) {
        pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
        pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
      }

      const price = document.getElementById(`price-${this.dataset.section}-${this.dataset.productId}`);
      if (price) price.classList.remove('visibility-hidden');
      if (inventoryDestination)
        inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId,
          html,
          variant: this.currentVariant,
        },
      });
    });
}

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}-${this.dataset.productId}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    if (!this.variantData) {
      const script = this.querySelector('[type="application/json"]');
      if (script) {
        this.variantData = JSON.parse(script.textContent);
      } else if (this.dataset.variants) {
        try {
          this.variantData = JSON.parse(this.dataset.variants);
        } catch (e) {
          console.error('Failed to parse data-variants attribute', e);
          this.variantData = [];
        }
      } else {
        this.variantData = [];
      }
    }
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);


class VariantRadios extends VariantSelects {
  constructor() {
    super();
    // A flag to see if this component is running in the special dispenser context
    this.isPresaleContext = this.closest('.presale-product-wrapper[data-enable-dispenser-style-logic]');
    this.sumDispenser = [];

    // Add event listener for the main variant change
    this.addEventListener('change', this.onVariantChange);

    // If in the special context, add listeners for the custom dispenser inputs
    if (this.isPresaleContext) {
      this.querySelectorAll("[name='# of Free Dispensers']").forEach(input => {
        input.addEventListener('click', this.handleFreeDispensersChange.bind(this));
      });
      this.querySelectorAll('[name^="custom-dispenser-styles"]').forEach(input => {
        input.addEventListener('change', this.handleCustomDispenserStyleChange.bind(this));
      });
    }
  }

  /**
   * Main event handler, now with logic to identify the element that was changed.
   */
onVariantChange(event) {
  if (this.maybeNavigateToCombinedListingProduct(event)) return;

  const lastChangedInput = event.target;

  // Step 1: Disable ATC immediately
  //this.toggleAddButton(true, '', false); // prevent class flickering

  // Step 2: Run variant logic
  this.updateOptions(lastChangedInput);
  this.updateMasterId();

  if (!this.currentVariant) {
  //  this.toggleAddButton(true, '', true);
    this.setUnavailable();
  } else {
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.updateShareUrl();

    // Step 3: Wait for product info to render before re-enabling button
this.renderProductInfo().then(() => {
  // Use a short delay to let the new DOM update fully render
  requestAnimationFrame(() => {
    const priceVal = document.querySelector(`#price-${this.dataset.section} .price-item--regular`)?.innerHTML;
    //this.toggleAddButton(false, '', true, priceVal);
  });
});

  }

  this.updateVariantStatuses();
}


  /**
   * The new central controller for variant logic.
   * It now finds the closest available variant and updates the UI directly
   * without causing update loops.
   */
  updateOptions(lastChangedInput) {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    let currentSelections = fieldsets.map((fieldset) => {
      return fieldset.querySelector('input:checked')?.value;
    });

    this.updateMasterId(currentSelections);
    
    // If the current combination is unavailable, find a better one.
    if (!this.currentVariant || !this.currentVariant.available) {
      const newVariant = this.getClosestAvailableVariant(lastChangedInput);
      
      if (newVariant) {
        let lastProgrammaticallyChangedInput = null;
        // A new valid variant was found, so update the radio buttons directly
        fieldsets.forEach((fieldset, index) => {
          const correctValue = newVariant.options[index];
          const inputToSelect = fieldset.querySelector(`input[value="${correctValue}"]`);
          if (inputToSelect) {
            inputToSelect.checked = true; //doesn't fire a change event
            lastProgrammaticallyChangedInput = inputToSelect;
          }
        });

        // fires change event
        if (lastProgrammaticallyChangedInput) {
          lastProgrammaticallyChangedInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        
      }
    }

    // Finally, read the confirmed state of the options
    this.options = fieldsets.map((fieldset) => {
      return fieldset.querySelector('input:checked')?.value;
    });
  }

  /**
   * A much smarter way to find a fallback variant. It prioritizes the user's last selection.
   */
  getClosestAvailableVariant(lastChangedInput) {
    const lastChangedName = lastChangedInput.name;
    const lastChangedValue = lastChangedInput.value;
    const availableVariants = this.getVariantData().filter(v => v.available);

    // Find which option group was changed (e.g., option1, option2, or option3)
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const lastChangedIndex = fieldsets.findIndex(fieldset => fieldset.querySelector(`input[name="${lastChangedName}"]`));
    
    // 1. Ideal case: Find an available variant that matches the user's last click.
    let bestMatch = availableVariants.find(variant => variant.options[lastChangedIndex] === lastChangedValue);
    
    // 2. Fallback: If no direct match, find one that respects the first option (e.g., "Size").
    if (!bestMatch) {
      const firstOptionValue = this.querySelector('fieldset:first-of-type input:checked')?.value;
      bestMatch = availableVariants.find(variant => variant.option1 === firstOptionValue);
    }
    
    // 3. Last resort: If still no match, just get the first available variant overall.
    if (!bestMatch) {
      bestMatch = availableVariants[0];
    }
    
    return bestMatch;
  }

  /**
   * Overridden from VariantSelects to use the new options logic.
   */
  updateMasterId(options = this.options) {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return options[index] === option;
      }).includes(false);
    });

    if (!this.currentVariant) {
      this.currentVariant = this.getSoleVariantFallback();
    }
  }

  /**
   * This logic now runs last to correctly disable options that are truly unavailable
   * with the final, corrected selection.
   */
  updateVariantStatuses() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const currentOptions = fieldsets.map(fs => fs.querySelector('input:checked')?.value);

    const getLabelForInput = (input) => {
      // Prefer explicit for=… mapping
      let lbl = input.id ? input.closest('fieldset')?.querySelector(`label[for="${input.id}"]`) : null;
      // Fallback: adjacent sibling label
      if (!lbl && input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') {
        lbl = input.nextElementSibling;
      }
      return lbl;
    };

    fieldsets.forEach((fieldset, index) => {
      // For other groups, determine availability based on previous selections
      const inputs = Array.from(fieldset.querySelectorAll('input'));
      const relevantVariants = this.getVariantData().filter(variant => {
        for (let i = 0; i < index; i++) {
          if (variant.options[i] !== currentOptions[i]) return false;
        }
        return true;
      });

      let hasAvailableInput = false;
      const availableInputs = [];

      inputs.forEach(input => {
        // Combined listings: option_values that point at sibling child products have
        // a non-empty data-product-url. They aren't part of THIS product's variant
        // matrix, so getVariantData() never matches them — without this guard they
        // would be marked unavailable and hidden as soon as the user touches any
        // local option (e.g. a size). Preserve their server-rendered visibility and
        // count them toward hasAvailableInput so the fieldset stays enabled.
        if (input.dataset && input.dataset.productUrl) {
          hasAvailableInput = true;
          availableInputs.push(input);
          return;
        }

        const isAvailable = relevantVariants.some(
          variant => variant.options[index] === input.value && variant.available
        );

        const label = getLabelForInput(input);

        if (isAvailable) {
          input.classList.remove('disabled');

          // Apply to inner wrapper element, not the outer .product-variant-picker-option-wrapper
          const innerWrapper = input.closest('.product-variant-picker-option-wrapper *');
          if (innerWrapper && innerWrapper !== fieldset) {
            innerWrapper.classList.remove('disabled');
          }

          if (label) label.style.display = ''; // show
          hasAvailableInput = true;
          availableInputs.push(input);
        } else {
          input.classList.add('disabled');

          const innerWrapper = input.closest('.product-variant-picker-option-wrapper *');
          if (innerWrapper && innerWrapper !== fieldset) {
            innerWrapper.classList.add('disabled');
          }

          if (label) label.style.display = 'none'; // hide
        }
      });

      // Disable the fieldset only if no inputs are available
      fieldset.classList.toggle('disabled', !hasAvailableInput);

      const shouldCollapseYesNo =
        fieldset.dataset.yesNoOption === 'true' &&
        fieldset.dataset.combinedOptionHidden !== 'true' &&
        availableInputs.length <= 1;

      if (fieldset.dataset.combinedOptionHidden !== 'true') {
        fieldset.style.display = shouldCollapseYesNo ? 'none' : '';
        fieldset.toggleAttribute('aria-hidden', shouldCollapseYesNo);
      }

      fieldset.classList.toggle('is-collapsed-yes-no-option', shouldCollapseYesNo);

      if (shouldCollapseYesNo && availableInputs.length === 1 && !availableInputs[0].checked) {
        availableInputs[0].checked = true;
        this.options = fieldsets.map(fs => fs.querySelector('input:checked')?.value);
        this.updateMasterId(this.options);
        if (this.currentVariant) this.updateVariantInput();
      }

      const checkbox = fieldset.querySelector('.variant-checkbox-wrapper[data-yes][data-no]');
      if (checkbox) {
        const checkedInput = fieldset.querySelector('input:checked');
        const isYesSelected = checkedInput && checkedInput.value === checkbox.dataset.yes;
        checkbox.classList.toggle('checked', Boolean(isYesSelected));
        checkbox.setAttribute('aria-checked', isYesSelected ? 'true' : 'false');
      }
    });
  }


  // --- Integrated Dispenser Logic ---
  
  handleFreeDispensersChange(event) {
    this.sumDispenser = [];
    const dispenserSelectors = this.querySelectorAll('.select-dispenser-style');
    dispenserSelectors.forEach(sel => sel.classList.remove('show'));
    this.querySelectorAll('[name^="custom-dispenser-styles"]:checked').forEach(radio => radio.checked = false);
    
    const count = event.target.value;
    for (let i = 1; i <= count; i++) {
      this.querySelector(`.select-dispenser-style-${i}`)?.classList.add('show');
    }
  }
  
  handleCustomDispenserStyleChange() {
    const checkedCustomStyles = this.querySelectorAll('[name^="custom-dispenser-styles"]:checked');
    const freeDispenserCount = parseInt(this.querySelector("[name='# of Free Dispensers']:checked")?.value || 0);

    this.sumDispenser = Array.from(checkedCustomStyles).map(input => input.value);
    
    if (freeDispenserCount === this.sumDispenser.length) {
      const glassCount = this.sumDispenser.filter(v => v === 'Glass').length;
      const plasticCount = this.sumDispenser.filter(v => v === 'HDPE').length;
      let variantString = '';

      if (glassCount > 0 && plasticCount === 0) variantString = `${glassCount} Glass`;
      if (plasticCount > 0 && glassCount === 0) variantString = `${plasticCount} HDPE`;
      if (glassCount > 0 && plasticCount > 0) variantString = `${glassCount} Glass & ${plasticCount} HDPE`;
      
      // Instead of clicking, we find the input and trigger the main change event
      const targetInput = this.querySelector(`fieldset input[value="${variantString}"]`);
      if (targetInput) {
        targetInput.checked = true;
        this.onVariantChange(new Event('change', { detail: { target: targetInput } }));
      }
    }
  }
}

customElements.define('variant-radios', VariantRadios);




class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  loadRecommendations() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.dataset.recommendationsLoaded = 'true';
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }

        document.dispatchEvent(new CustomEvent('recommendations::loaded'));
      })
      .catch((e) => {
        console.error(e);
      });
  }

  connectedCallback() {
    // Re-attachment (CartDrawer.renderContents preserves the live upsell across the
    // drawer's innerHTML swap via replaceWith) re-fires this callback; re-fetching
    // would wipe the live carousel and replay its entrance animation.
    if (this.dataset.recommendationsLoaded === 'true') return;

    // Inside the slide cart the element lives off-canvas, so an IntersectionObserver
    // wouldn't fire until the drawer opens — which is why the upsell used to pop in
    // late. Fetch eagerly there so the upsell is already present when the cart opens.
    if (this.closest('cart-drawer')) {
      this.loadRecommendations();
      return;
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.loadRecommendations();
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class ProductRecommendationsWithoutIntersection extends HTMLElement {
  constructor() {
    super();
    this.productRecommnendations = this.querySelectorAll('product-recommendations-without-intersection-item');
  }

  fetchData(elm, url) {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations-without-intersection-item');
        if (recommendations && recommendations.innerHTML.trim().length) {
          const cardRecommendations = html.querySelectorAll('.cart-upsell-recommendations');
          if (cardRecommendations.length) {
            elm.innerHTML = recommendations.innerHTML;
            setTimeout(() => {
              elm.classList.add('has-product-recommendation');
            }, 100)
          }
        }
        document.dispatchEvent(new CustomEvent('recommendations::loaded'));
      })
      .catch((e) => {
        console.error(e);
      });
  }

  connectedCallback() {
    this.looper();
  }

  async looper() {
    for (var start = 0; start < this.productRecommnendations.length; start++) {
      const elm = this.productRecommnendations[start];
      const url = this.productRecommnendations[start].dataset.url;
      this.fetchData(elm, url);
    }
    return true;
  }
}

customElements.define('product-recommendations-without-intersection', ProductRecommendationsWithoutIntersection);

/**
 * Accessible tabs for the PDP info tabs (snippets/product-tab-info.liquid).
 * Panel switching itself (the `.active` classes) is done by the delegated
 * [data-tabs-header-item] click handler in assets/main.js; this only keeps the
 * ARIA state in sync with it and adds arrow-key / Home / End navigation.
 */
(() => {
  const TAB_SELECTOR = '[data-tabs] [role="tablist"] [role="tab"]';

  const syncTabs = (activeTab) => {
    const tablist = activeTab.closest('[role="tablist"]');
    if (!tablist) return;
    tablist.querySelectorAll('[role="tab"]').forEach((tab) => {
      tab.setAttribute('aria-selected', tab === activeTab ? 'true' : 'false');
    });
  };

  // Panels rendered by other snippets (e.g. product-whats-included) can't carry
  // the tabpanel role in their own markup, so label them from their tab here.
  const labelPanels = (root) => {
    root.querySelectorAll(TAB_SELECTOR).forEach((tab) => {
      const container = tab.closest('[data-tabs]');
      const panelId = tab.getAttribute('aria-controls');
      if (!container || !panelId) return;
      const panel = container.querySelector(`[id="${CSS.escape(panelId)}"]`);
      if (!panel || panel.hasAttribute('role')) return;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
    });
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest(TAB_SELECTOR);
    if (tab) syncTabs(tab);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest(TAB_SELECTOR);
    if (!tab) return;
    const tabs = Array.from(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
    const index = tabs.indexOf(tab);
    let next = null;
    if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
    else if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
    else if (event.key === 'Home') next = tabs[0];
    else if (event.key === 'End') next = tabs[tabs.length - 1];
    if (!next) return;
    event.preventDefault();
    next.focus();
    next.click();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => labelPanels(document));
  } else {
    labelPanels(document);
  }
})();
